import { IResourceComponentsProps, useExport, useNavigation, useShow } from '@pankod/refine-core'
import { CSVLink } from 'react-csv'
import React, { useEffect, useState } from 'react'
import { getThemeData } from 'gql/query'

import {
  List,
  RefreshButton,
  CreateButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  useImport,
  ImportButton,
  Input,
  Divider,
  useTable,
  Form,
  Button,
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'

import { ITheme } from 'interfaces'
import { CreateTheme } from './create'
import { EditTheme } from './edit'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import Permissions from 'permissions'
import { createUserHistory } from 'gql/mutations'
import { themeImportFormat } from 'helpers/import_template_format/importTemplate'

type Permission = {
  granted?: boolean
}
const { PlusOutlined, ExportOutlined } = Icons

export const ThemesList: React.FC<IResourceComponentsProps> = () => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const { push } = useNavigation()
  const [pagination, setHasPagination] = useState<any>(true)
  const hiddenRole = ['srmanager', 'subjectincharge', 'qreviewer', 'qcreator', 'qapprover']
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})

  const metaData = {
    fields: [
      'id',
      'name',
      'subject_id',
      { subject: ['name'] },
      'created_at',
      // 'report_theme_id',
      // { report_theme: ['name'] },
      { paper_template_sub_sections: ['id'] },
      { work_requests: ['id'] },
      { questions: ['id'] },
      { sub_themes: ['id'] },
    ],
  }
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('themes'))
      setCreatePermission(Permissions.can(userRole).createAny('themes'))
      setEditPermission(Permissions.can(userRole).updateAny('themes'))
      setDeletePermission(Permissions.can(userRole).deleteAny('themes'))
    }
  }, [userRole])
  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
  }, [readPermission, userRole])
  const { tableProps, searchFormProps, sorter, tableQueryResult, setFilters } = useTable<ITheme>({
    hasPagination: pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: (values: any) => {
      return [
        {
          field: 'name',
          operator: 'contains',
          value: `%${values.title}%`,
        },
      ]
    },
  })
  const { queryResult, setShowId } = useShow<ITheme>({
    resource: 'themes',
    metaData: metaData,
  })
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  const { formProps, modalProps, show } = useModalForm({
    resource: 'themes',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'themes',
    action: 'edit',
    metaData,
  })
  const [tableData, setTableData] = useState([])

  const importProps = useImport<ITheme>({
    mapData: item => {
      return {
        name: item.name,
        subject_id: item.subject_id,
        // report_theme_id: item.report_theme_id,
        created_by: user?.id,
      }
    },
    onFinish(results) {
      if (results?.succeeded) createUserHistory('themes', 'import', '', user?.id, userRole)
    },
  })

  const hideDeleteButton = (record: ITheme): boolean => {
    let ptss = record?.paper_template_sub_sections
    let wr = record?.work_requests
    let q = record?.questions
    let st = record?.sub_themes
    if (ptss !== undefined && wr !== undefined && q !== undefined && st !== undefined) {
      const shouldHide = ptss.length > 0 || wr.length > 0 || q.length > 0 || st.length > 0
      return shouldHide
    }
    return false
  }

  useEffect(() => {
    getThemeData().then((resp: any) => {
      let exportData: any = []
      resp.themes.forEach(async (element: any) => {
        let mockObj = {
          id: element?.id,
          name: element?.name,
          subject_id: element?.subject_id,
          subject_name: element?.subject.name,
          // report_theme_id: element?.report_theme_id,
          // report_theme: element?.report_theme?.name,
          created_at: element?.created_at,
        }
        exportData.push(mockObj)
      })
      setTableData(exportData)
    })
  }, [tableQueryResult?.data?.data])

  const csvData = [themeImportFormat.map(item => item.toString())]

  return (
    <>
      <List
        pageHeaderProps={{
          extra: [
            !hiddenRole?.includes(userRole) ? <ImportButton {...importProps} /> : null,

            <CSVLink
              data={tableData}
              asyncOnClick={true}
              filename={`Themes_${Math.round(new Date().getTime() / 1000)}`}
              className="ant-btn ant-btn-default"
              hidden={hiddenRole?.includes(userRole)}
              onClick={() => createUserHistory('themes', 'export', '', user?.id, userRole)}
            >
              <ExportOutlined /> Export
            </CSVLink>,

            <RefreshButton onClick={() => tableQueryResult?.refetch()} />,

            <CreateButton
              style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => show()}
            />,
          ],
        }}
      >
        <Form {...searchFormProps}>
          <Space>
            <Form.Item name="title">
              <Input
                placeholder="Search by title"
                allowClear
                onChange={e => {
                  if (e.type === 'click') {
                    searchFormProps.form?.submit()
                  }
                }}
              />
            </Form.Item>
            <Button icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
              Search
            </Button>
            {!(userRole === 'qcreator' || userRole === 'qreviewer' || userRole === 'qapprover') && (
              <Button key="export paper" type="default" style={{ marginLeft: '5px' }}>
                <CSVLink key="export" data={csvData} filename={`theme_ImportFormat${Math.round(new Date().getTime() / 1000)}`}>
                  <ExportOutlined /> Download Import Format
                </CSVLink>
              </Button>
            )}
          </Space>
        </Form>
        <Divider />
        <Table {...tableProps}>
          <Table.Column dataIndex="name" title="Name" />

          <Table.Column<ITheme> dataIndex="subject_id" render={(_, record) => record.subject.name} title="Subject" />
          {/* <Table.Column<ITheme> dataIndex="report_theme_id" render={(_, record) => record?.report_theme?.name} title="Report Theme" /> */}

          <Table.Column
            dataIndex="created_at"
            title="Created At"
            render={value => <DateField value={value} format="LLL" />}
            defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
            sorter
          />
          <Table.Column<ITheme>
            title="Actions"
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                {editPermission !== undefined && editPermission.granted ? (
                  <EditButton
                    size="small"
                    type="link"
                    icon={null}
                    recordItemId={record.id}
                    hidden={
                      (record?.questions && record?.questions?.length > 0) ||
                      (record?.paper_template_sub_sections && record?.paper_template_sub_sections.length > 0) ||
                      userRole === 'qcreator' ||
                      userRole === 'qapprover' ||
                      userRole === 'qreviewer'
                    }
                    onClick={() => {
                      setShowId(record.id)
                      editShow(record.id)
                    }}
                  />
                ) : null}
                {deletePermission !== undefined && deletePermission.granted ? (
                  <DeleteButton
                    size="small"
                    type="link"
                    icon={null}
                    recordItemId={record.id}
                    hidden={hideDeleteButton(record) || userRole === 'qcreator' || userRole === 'qapprover' || userRole === 'qreviewer'}
                  />
                ) : null}
              </Space>
            )}
          />
        </Table>
        <CreateTheme modalProps={modalProps} formProps={formProps} />
        <EditTheme modalProps={editModalProps} formProps={editFormProps} record={record} />
      </List>
    </>
  )
}
